module.exports = __webpack_public_path__ + "static/media/virus.d6ec837d.svg";